Ext.define('SA.model.map.ExportOverlay', {
    extend: 'Ext.data.Model',
    mixins: ['SA.model.ObservableChangeMixin'],

    fields: [
        {name: 'x', type: 'proportion'},
        {name: 'y', type: 'proportion'},

        {name: 'width', type: 'proportion'},

        'visible',

        {name: 'aspectRatio', defaultValue: 1},

        {name: 'aspectRatioWidth', defaultValue: 0}
    ],

    getAspectRatio() {
        return this.get('aspectRatio');
    },

    getWidth() {
        return this.get('width');
    },

    getX() {
        return this.get('x');
    },

    getY() {
        return this.get('y');
    },

    isVisible() {
        return this.get('visible');
    },

    setAspectRatio(ratio, width) {
        this.set({
            aspectRatio: ratio,
            aspectRatioWidth: width
        });
    },

    setDimensions(values) {
        this.setWithEvent(values, 'set:dimensions');
    },

    setVisible(visible) {
        this.setWithEvent('visible', visible);
    },

    updateAspectRatio(width, height) {
        if (this.get('aspectRatioWidth') < width) {
            this.setAspectRatio(height / width, width);
        }
    }
});